import * as React from "react";
import ErrorMessageProps from "./IErrorMessage";
import "../../../assets/sass/widgets/datePickerWidget.scss";
import { imagePathurl } from "../../utils/utils";
/**
 * @class ErrorMessage
 * @param props
 * @constructor
 * @category components
 * @description components used for showing various type of labels used in other components and its sections
 */
const ErrorMessage: React.FC<ErrorMessageProps> = (props) => {
    const { errorDetails, errorState, propId } = props;
    const imagePath = imagePathurl();
    return (
        <>
            {errorDetails &&
                !errorDetails[propId] &&
                errorState &&
                errorState.error &&
                errorState.errorMessage.length > 0 && (
                    <div className="error-message">
                        {errorState.errorMessage.map((msg, id) => (
                            <p key={id}>
                                <img className="ccz-img" src={`${imagePath}error-field-icon.png`} alt="error" />
                                &nbsp;
                                {msg}
                            </p>
                        ))}
                    </div>
                )}
            {errorDetails && errorDetails[propId] && errorDetails[propId].length > 0 && (
                <div className="error-message">
                    {errorDetails[propId].map((msg, id) => (
                        <p key={id}>
                            <img className="ccz-img" src={`${imagePath}error-field-icon.png`} alt="error" />
                            &nbsp;
                            {msg}
                        </p>
                    ))}
                </div>
            )}
        </>
    );
};
export default ErrorMessage;
